if (!customElements.get('miez-header-menu')) customElements.define('miez-header-menu', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.items = [...this.querySelectorAll('.miez-header-menu__item')];
    this.items.forEach(item => {
      const toggle = item.querySelector('button');
      if (!toggle) return;
      item.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') this.open(item); });
      item.addEventListener('pointerleave', () => { if (!item.contains(document.activeElement)) this.close(item); });
      item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) this.close(item); });
      toggle.addEventListener('click', () => item.hasAttribute('data-open') ? this.close(item) : this.open(item));
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.close(item); toggle.focus(); event.preventDefault(); }
        if (event.key === 'ArrowDown' && !event.target.closest('.miez-header-menu__panel')) {
          this.open(item); item.querySelector('.miez-header-menu__panel a').focus(); event.preventDefault();
        }
      });
    });
    this.outside = event => { if (!this.contains(event.target)) this.items.forEach(item => this.close(item)); };
    document.addEventListener('pointerdown', this.outside);
  }
  disconnectedCallback() { document.removeEventListener('pointerdown', this.outside); this.initialized = false; }
  open(item) { this.items.forEach(other => { if (other !== item) this.close(other); }); item.setAttribute('data-open',''); item.querySelector('button').setAttribute('aria-expanded','true'); item.querySelector('.miez-header-menu__panel').hidden = false; }
  close(item) { item.removeAttribute('data-open'); const button=item.querySelector('button'); if (button) { button.setAttribute('aria-expanded','false'); item.querySelector('.miez-header-menu__panel').hidden=true; } }
});
